import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Medication } from '../../models/medication.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-prescription',
  templateUrl: './create-prescription.modal.html',
  imports: [ReactiveFormsModule, CommonModule],
  styleUrls: ['./create-prescription.modal.scss'],
})
export class CreatePrescriptionModal {
  prescriptionForm: FormGroup;

  // Mock data
  availableMedications = ['Ibuprofen', 'Paracetamol', 'Amoxicillin', 'Aspirin'];
  frequencyOptions = ['Once daily', 'Twice daily', 'After meals', 'Before bedtime'];
  ingestionMethods = ['Oral', 'Skin Cream', 'Injection', 'Eye Drop', 'Other'];

  medications: Medication[] = [];

  // constructor(private fb: FormBuilder) {
  //   this.prescriptionForm = this.fb.group({
  //     frequency: '',
  //     name: '',
  //     dosage: '',
  //     ingestionMethod: ''
  //   });
  // }

  constructor(
    public dialogRef: MatDialogRef<CreatePrescriptionModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) {
    // Initialize properties with data passed to the modal
    this.prescriptionForm = this.fb.group({
      frequency: ['', Validators.required],
      name: ['', Validators.required],
      dosage: ['', Validators.required],
      ingestionMethod: ['', Validators.required],
    });
  }

  // Add new medication field set
  addMedication() {
    let freq = this.prescriptionForm.get('frequency')?.value;
    let name = this.prescriptionForm.get('name')?.value;
    let dosage = this.prescriptionForm.get('dosage')?.value;
    let ingestionMethod = this.prescriptionForm.get('ingestionMethod')?.value;

    this.medications.push({
      appliedArea: ingestionMethod,
      name: name,
      dosage: dosage,
      frequency: freq,
    });

    // Reset form for next medication
    this.prescriptionForm.reset();
  }

  // Generate prescription
  generatePrescription() {
    this.dialogRef.close(this.medications);
  }

  // Cancel prescription
  cancelPrescription() {
    this.dialogRef.close();
  }
}
